import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'

import { colors } from 'Constants'
import { getReport, getReportLevel } from '../helpers'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import ReportHeader from '../components/ReportHeader'
import DeviceReport from './components/DeviceReport'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

export default ({ appCode }) => {
  const reportSortingState = useStore(ReportSortingStore)
  const [
    { startDate, endDate, officeId, patientRef, device, showArchivedOffices },
    setQuery
  ] = useQueryParams()
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(true)

  const title = getReportLevel(officeId, patientRef)

  useEffect(async () => {
    setReports(
      await getReport('/reports/device/get', {
        appCode,
        startDate,
        endDate,
        officeId,
        patientRef,
        device,
        showArchivedOffices
      })
    )
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`${title} Device Report`}
        csvUrl="/reports/device/csv"
        csvPayload={reportSortingState}
        appCode={appCode}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reports.map(report => (
        <>
          <ReportHeader
            header="Office"
            title={report.title}
            cardValues={[
              ['Total', 'Responses', report.totalBreakdown.totalResponses],
              [
                'Total',
                'BT Cuff Responses',
                report.totalBreakdown.totalResponsesWithBpCuff
              ],
              [
                'Total',
                'Non-BT Cuff Responses',
                report.totalBreakdown.totalResponsesWithNoBpCuff
              ],
              ['Total', 'Journeys', report.totalBreakdown.totalJourneys]
            ]}
          />
          <ReportHeader
            header=" "
            title=" "
            cardValues={[
              ['Total', 'Patients', report.totalBreakdown.totalPatients],
              [
                'Total',
                'BT Cuff Patients',
                report.totalBreakdown.totalPatientsWithBpCuff
              ],
              [
                'Total',
                'Non-BT Cuff Patients',
                report.totalBreakdown.totalPatientsWithNoBpCuff
              ]
            ]}
          />
          <DeviceReport report={report} />
        </>
      ))}
    </>
  )
}
